import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  emoji: '📗',
  number: 'TOMO 1',
  title: 'EL DESPERTAR',
  subtitle: 'Desayunos, Brunchs y Panificados',
  desc: 'Panqueques de avena, tostadas de palta, revueltos de tofu, panes caseros, licuados y leches vegetales. Arrancá el día con energía real.'
}, {
  emoji: '📘',
  number: 'TOMO 2',
  title: 'EL BANQUETE DIARIO',
  subtitle: 'Almuerzos y Cenas de 20 Minutos',
  desc: 'Bowls de autor, sopas cremosas, platos únicos al horno, salteados express y platos rápidos para los días reales.'
}, {
  emoji: '📙',
  number: 'TOMO 3',
  title: 'EL REY DE LA MESA',
  subtitle: 'Proteínas Vegetales y Texturas Argentinas',
  desc: 'Hamburguesas que no se desarman, milanesas de soja napolitanas, chorizos vegetales, albóndigas de lentejas y el asado vegetal criollo.'
}, {
  emoji: '📕',
  number: 'TOMO 4',
  title: 'EL ALQUIMISTA',
  subtitle: 'Lácteos Vegetales, Quesos y Salsas Cremosas',
  desc: 'Muzza vegana que derrite, queso crema de girasol, dulce de leche vegano, bechamel de avena y mayonesa sin huevo.'
}, {
  emoji: '📓',
  number: 'TOMO 5',
  title: 'CELEBRACIÓN Y PICADAS',
  subtitle: 'Finger Food, Platos de Fiesta y Recetas para Compartir',
  desc: 'Empanadas de pino vegano, choripán vegetal, fugazzeta rellena, hummus de remolacha, pizzas napolitanas y picadas completas.'
}, {
  emoji: '📔',
  number: 'TOMO 6',
  title: 'DULCE FINAL',
  subtitle: 'Repostería Argentina Vegana',
  desc: 'Alfajores de maicena veganos, torta rogel de dulce de leche de coco, brownies de cacao, postre chajá vegano y helado de dulce de leche.'
}];
export function ProductContent() {
  return <section className="bg-[#18181b] py-12 pb-6 px-4" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-167">
            ¿Qué hay adentro del Pack Cocina Veggie?
          </h2>
          <p className="text-lg text-emerald-400 font-medium" data-id="element-168">
            6 Tomos PDF + 6 Bonos — Todo diseñado para Argentina
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-169">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -15 : 15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-[#0a0a0a] border border-zinc-800 border-l-4 border-l-emerald-500 rounded-r-lg p-5 flex flex-col" data-id="element-170">
              <div className="flex items-center gap-3 mb-2" data-id="element-171">
                <span className="text-2xl" data-id="element-172">{tomo.emoji}</span>
                <div data-id="element-173">
                  <span className="text-emerald-500 text-xs font-bold tracking-wider" data-id="element-174">
                    {tomo.number}
                  </span>
                  <h3 className="text-lg font-bold text-white leading-tight" data-id="element-175">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <h4 className="text-zinc-300 text-sm font-medium mb-1" data-id="element-176">
                {tomo.subtitle}
              </h4>
              <p className="text-zinc-400 text-xs leading-relaxed" data-id="element-177">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}